import * as $ from 'jquery';
import 'inputmask/dist/inputmask/inputmask.numeric.extensions';
import * as Inputmask from 'inputmask/dist/inputmask/inputmask.date.extensions';

// jQuery Datepicker
import 'jquery-mask-plugin';
import 'jquery-datetimepicker';
// jQuery Datepicker

// Angular
import {  NgControl } from '@angular/forms';
import {
    Input,
    Output,
    OnInit,
    Optional,
    Directive,
    Renderer2,
    ElementRef,
    HostListener,
    EventEmitter
} from '@angular/core';
// Angular

// Interfaces
import {
    IConfig,
    IConfigMask
} from './jquery-date-picker.directive.interface';
// Interfaces

@Directive({
  selector: '[appJqueryDatePicker]',
  exportAs: 'appJqueryDatePicker'
})
export class JqueryDatePickerDirective implements OnInit {
    elem: any;
    triggers: string;

    @Input() appJqueryDatePicker: any;
    @Input() appJqueryDatepickerConfig: IConfig;
    @Input() appJqueryDatePickerMaskConfig: IConfigMask;

    @Output() appOnJqueryDatePickerChanged: EventEmitter<any> = new EventEmitter();

    constructor(
        private el: ElementRef,
        private renderer2: Renderer2,
        @Optional() private control: NgControl
    ) {
        this.elem = $(this.el.nativeElement);
    }

    ngOnInit() {
        if (typeof(this.control.control) !== 'undefined') {
            if (this.control.control.value !== null) {
                this.appJqueryDatepickerConfig.value = this.control.control.value;
            }
        }

        this.appJqueryDatepickerConfig.onSelectDate = ((ct) => {
            const _year = ct.getFullYear(),
                _date = ct.getDate().toString(),
                _month = (ct.getMonth() + 1).toString();
            const _value = (
                ( _month.length < 2 ? '0' + _month : _month )
                + '/'
                + (_date.length < 2 ? '0' + _date : _date)
                + '/'
                + _year
            );
            const _formattedDate =  Inputmask.format(_value, {
                alias: 'datetime',
                inputFormat: 'mm/dd/yyyy'
            });

            if (typeof(this.control.control) !== 'undefined') {
                this.control.control.setValue(_formattedDate);
            }
        });
        this.elem.datetimepicker(this.appJqueryDatepickerConfig);
        this.maskElement();
    }

    @Output()
    toggle() {
        if (this.isMobile()) {
            return true;
        }
        this.elem.datetimepicker('toggle');
    }

    @HostListener('blur', ['$event'])
    private onBlur (event) {
        if (this.control && event.target.value !== '') {
            const tmp = new Date(event.target.value);
            if (tmp.toString() === 'Invalid Date') {
                this.control.control.setValue('');
            } else {
                this.control.control.setValue(event.target.value);
            }
        }
        this.maskElement();
    }

    private isMobile () {
        const isMobileDetected = (<any> window).isWFSDirectMobile;

        if (isMobileDetected !== undefined) {
            if (isMobileDetected) {
                return isMobileDetected;
            }
        }

        return false;
    }

    private maskElement() {
        this.elem.mask(this.appJqueryDatePickerMaskConfig.mask, '');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/jquery-date-picker/jquery-date-picker.directive.ts